const VkRetargetEvent = eventName => window.VK.Retargeting.Event(eventName);

export default VkRetargetEvent;
